'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _package = { version: '2.13.11' };

exports['default'] = _package.version;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/version/index.js
// module id = 694
// module chunks = 0